package com.eladfinish.bible.contest.screens.chapterComplete.api

import com.eladfinish.bible.contest.network.DefaultApiResult
import com.eladfinish.bible.contest.network.apiResultUTF8
import com.eladfinish.bible.contest.screens.chapterComplete.model.BlanksData
import io.ktor.client.HttpClient
import io.ktor.client.request.get

interface ChapterCompleteApi {
    suspend fun getPresetBlanks(): DefaultApiResult<BlanksData>
}

class ChapterCompleteApiImpl(
    private val client: HttpClient,
) : ChapterCompleteApi {

    companion object {
        const val remoteFile = "https://biblecontest-f3b7c.firebaseio.com/blanks.json"
    }

    override suspend fun getPresetBlanks(): DefaultApiResult<BlanksData> = apiResultUTF8 {
        client.get(remoteFile)
    }

}
